import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getMessage } from "CONFIG/i18n";
import withErrorHandler from "COMPONENTS/withErrorHandler/withErrorHandler";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';

// WebSocket
import { sendWebsocketMessage } from "WEBSOCKET/WebsocketHandler";
import { socketMessage } from "WEBSOCKET/constants";

// components
import Spinner from "COMPONENTS/Spinner/Spinner";
import { selectIsSnapShotRunning, getIsScreenMasking } from "REDUX/Selector/SessionSelector";
import { customerCoBrowseAction } from "CONFIG/ActionFactory";
import TargetSiteSelectionModal from "./TargetSiteSelectionModal";
import CustomerCoBrowse from "./CustomerCoBrowse";

// Actions
import { headerAction } from "CONFIG/ActionFactory";

//UTILS
import { Modules } from "UTILS/Constants";

// selector
import {
  getAdmittedParticipants, getParticipantLeftCustomerCoBrowse, getParticipantJoinedCustomerCoBrowse,
  getParticipantDeniedCustomerCoBrowse, getLayoutCode, getRoomId, getShareUrl, selectPresenter, getAgentEmailFromParticipants,
  selectCoBrowseBaseUrl, getShowCustomerCoBrowse, selectMutualEdit
} from "./CustomerCoBrowseSelector";

class CustomerCoBrowseContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerVisibility: false,
      cobrowseDetails: {
        allowCustomUrl: false,
        targetSites: [],
        coBrowseType: ""
      },
      presenterSelectMutualEdit: false
    };
  }

  componentDidMount() {
    if (this.isPresenter()) {
      this.getCobrowseTargetSites();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.cobrowseDetails.targetSites !== this.state.cobrowseDetails.targetSites) {
      this.setState({ cobrowseDetails: this.state.cobrowseDetails });
    }
    if (this.props.participantLeftCustomerCoBrowseUniqueId &&
      this.props.participantLeftCustomerCoBrowseUniqueId !== this.props.uniqueId &&
      prevProps.participantLeftCustomerCoBrowseUniqueId !== this.props.participantLeftCustomerCoBrowseUniqueId) {
      const participantName = this.getParticipantName(this.props.participantLeftCustomerCoBrowseUniqueId)
      if (participantName) {
        toastr.info(getMessage("LEFT_CO_BROWSE", { userName: participantName }));
      }
    }
    if (this.props.participantJoinedCustomerCoBrowseUniqueId &&
      this.props.participantJoinedCustomerCoBrowseUniqueId !== this.props.uniqueId &&
      prevProps.participantJoinedCustomerCoBrowseUniqueId !== this.props.participantJoinedCustomerCoBrowseUniqueId) {
      const participantName = this.getParticipantName(this.props.participantJoinedCustomerCoBrowseUniqueId)
      if (participantName) {
        toastr.info(getMessage("JOINED_CO_BROWSE_SESSION", { userName: participantName }));
      }
    }
    if (this.props.participantDeniedCustomerCoBrowseUniqueId &&
      prevProps.participantDeniedCustomerCoBrowseUniqueId !== this.props.participantDeniedCustomerCoBrowseUniqueId) {
      const participantName = this.getParticipantName(this.props.participantDeniedCustomerCoBrowseUniqueId)
      if (participantName) {
        toastr.info(getMessage("CO_BROWSE_PERMISSION_DENIED", { userName: participantName }));
      }
    }
  }

  getCobrowseTargetSites = () => {
    customerCoBrowseAction.getCobrowseTargetSites(this.props.sessionKey).then(
      (response) => {
        if (response.data.data && response.data.data.targetSites) {
          response.data.data.targetSites.forEach((value, index, array) => {
            response.data.data.targetSites[index].url = Buffer.from(response.data.data.targetSites[index].url, 'base64').toString('ascii');
          });
        }
        response.data.data &&
        this.setState({
          cobrowseDetails: response.data.data
        });
      },
      (error) => {

      }
    );
  }

  getParticipantName = (uniqueId) => {
    if (uniqueId) {
      let participant = this.props.admittedParticipants.filter((participant) => participant.uniqueId === uniqueId)[0];
      return participant ? participant.userName : null;
    } else {
      return null;
    }
  }

  handleBookCoBrowseSession = (targetURL, layoutCode) => {
    this.setState({ spinnerVisibility: true });
    let requestData = {
      targetURL,
      originId_1: window._env_.CUSTOMER_CO_BROWSE_ORIGIN,
      originId_2: this.props.customerUriIdentifier,
      originId_3: this.props.sessionKey,
      originId_4: this.props.sessionName,
      originId_5: this.props.email,
      layoutCode: layoutCode,
      token: this.props.token,
      presenter_select_mutual_edit: this.state.presenterSelectMutualEdit
    };
    customerCoBrowseAction.handleBookCoBrowseSession(requestData).then(
      (response) => {
        this.setState({ spinnerVisibility: false });
        customerCoBrowseAction.updateParticipantCoBrowseStatus(this.props.uniqueId, true);
        customerCoBrowseAction.showHideCustomerCoBrowse(true);
        customerCoBrowseAction.showTargetSiteSelectionModalAction(false);
      },
      (error) => {
        this.setState({ spinnerVisibility: false });
        console.error(error);
        toastr.error(getMessage(error.code));
        customerCoBrowseAction.showTargetSiteSelectionModalAction(false);
      }
    );
  }

  isPresenter = () => {
    return this.props.uniqueId === this.props.presenterId;
  }

  handleCustomerCoBrowseEndSessionClick = () => {
    const message = {
      data: {
        category: socketMessage.category.CUSTOMER_CO_BROWSE,
        action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.END_SESSION,
        sessionKey: this.props.sessionKey,
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  }

  handleCustomerCoBrowseLeaveSessionClick = () => {
    const message = {
      data: {
        category: socketMessage.category.CUSTOMER_CO_BROWSE,
        action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.LEAVE_SESSION,
        sessionKey: this.props.sessionKey,
      }
    };
    headerAction.updateHeaderIconClass(
      Modules.CO_BROWSE,
      "moduleIcon cursorDisabled",
      "cursorDisabled"
    );
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  }

  /**
   * presenterSelectMutualEdit
   * Agents configure mutual edits
   * @param {*} toggleFlag Switch ON/OFF
   */
  onPresenterCoBrowseMutualEditSwitchClick = (toggleFlag) => {
    this.setState({
      presenterSelectMutualEdit: toggleFlag
    });
    // todo Sends the cross-edit values selected by the presenter to the CobBrowser's API
  }

  render() {
    return (
      <>
        <Spinner showSpinner={this.state.spinnerVisibility} />
        {
          this.props.showTargetSiteSelectionModal ?
            <TargetSiteSelectionModal
              handleBookCoBrowseSession={this.handleBookCoBrowseSession}
              handleTargetSiteSelectionModalToggle={this.props.handleTargetSiteSelectionModalToggle}
              cobrowseDetails={this.state.cobrowseDetails}
              layoutCode={this.props.layoutCode}
              getCobrowseTargetSites={this.getCobrowseTargetSites}
              isSnapshotRunning={this.props.isSnapshotRunning}
              mutualEdit={this.props.mutualEdit}
              presenterSelectMutualEdit={this.state.presenterSelectMutualEdit}
              onPresenterCoBrowseMutualEditSwitchClick={this.onPresenterCoBrowseMutualEditSwitchClick}
            /> :
            <CustomerCoBrowse
              roomId={this.props.roomId}
              shareUrl={this.props.shareUrl}
              userName={this.getParticipantName(this.props.uniqueId)}
              role={this.props.role}
              token={this.props.token}
              layoutCode={this.props.layoutCode}
              isPresenter={this.isPresenter}
              coBrowseBaseUrl={this.props.coBrowseBaseUrl}
              handleCustomerCoBrowseEndSessionClick={this.handleCustomerCoBrowseEndSessionClick}
              handleCustomerCoBrowseLeaveSessionClick={this.handleCustomerCoBrowseLeaveSessionClick}
              uniqueId={this.props.uniqueId}
              sessionKey={this.props.sessionKey}
              endCustomerCBSession={this.props.endCustomerCBSession}
              showCustomerCoBrowse={this.props.showCustomerCoBrowse}
              componentInFocus={this.props.componentInFocus}
              setComponentInFocus={this.props.setComponentInFocus}
              mutualEdit={this.props.mutualEdit}
              presenterSelectMutualEdit={this.state.presenterSelectMutualEdit}
              presenterId={this.props.presenterId}
              isScreenMasking={this.props.isScreenMasking}
            />
        }
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    token: state.SessionReducer.sessionDetails.token,
    customerUriIdentifier: state.OrganisationReducer.customerData.uri_identifier,
    sessionName: state.SessionReducer.sessionDetails.sessionName,
    sessionKey: state.SessionReducer.sessionDetails.sessionKey,
    email: getAgentEmailFromParticipants(state),
    uniqueId: state.SessionReducer.uniqueId,
    role: state.UserReducer.userDetails.role,
    participantLeftCustomerCoBrowseUniqueId: getParticipantLeftCustomerCoBrowse(state),
    participantJoinedCustomerCoBrowseUniqueId: getParticipantJoinedCustomerCoBrowse(state),
    participantDeniedCustomerCoBrowseUniqueId: getParticipantDeniedCustomerCoBrowse(state),
    admittedParticipants: getAdmittedParticipants(state),
    layoutCode: getLayoutCode(state),
    roomId: getRoomId(state),
    shareUrl: getShareUrl(state),
    presenterId: selectPresenter(state),
    coBrowseBaseUrl: selectCoBrowseBaseUrl(state),
    showCustomerCoBrowse: getShowCustomerCoBrowse(state),
    isSnapshotRunning: selectIsSnapShotRunning(state),
    mutualEdit: selectMutualEdit(state),
    presenterSelectMutualEdit: state.presenterSelectMutualEdit,
    isScreenMasking: getIsScreenMasking(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    sendWebsocketMessage: sendWebsocketMessage,
  }, dispatch);
};

export default withErrorHandler(connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerCoBrowseContainer));
